export interface Advance {
  receiptNumber: string;
  orderNumber: string;
  sellerName: string;
  clientName: string;
  methodOfPayment: string;
  paymentDate: string;
  value: number;
  state: string;
  url: string;
  cancelUrl: string;
  vouchers: string[];
  key: string;
  sellerCode: string;
  cancellationComments: string;
}

export interface CancelAdvanceRequest {
  key: string;
  date: string;
  sellerCode: string;
  cancellationComments: string;
}

export function AdvanceActions() {
  function infoAdvance(
    receiptNumber: string,
    orderNumber: string,
    sellerName: string,
    clientName: string,
    methodOfPayment: string,
    paymentDate: string,
    value: number,
    state: string,
    url: string,
    cancelUrl: string,
    vouchers: string[],
    key: string,
    sellerCode: string,
    cancellationComments: string
  ): Advance {
    return {
      receiptNumber: receiptNumber,
      orderNumber: orderNumber,
      sellerName: sellerName,
      clientName: clientName,
      methodOfPayment: methodOfPayment,
      paymentDate: paymentDate,
      value: value,
      state: state,
      url: url,
      cancelUrl: cancelUrl,
      vouchers: vouchers,
      key: key,
      sellerCode: sellerCode,
      cancellationComments: cancellationComments,
    };
  }

  function advanceCancelRequest(
    key: string,
    date: string,
    sellerCode: string,
    cancellationComments: string
  ): CancelAdvanceRequest {
    return {
      key: key,
      date: date,
      sellerCode: sellerCode,
      cancellationComments: cancellationComments,
    };
  }

  function deserialize(object: string): Advance[] {
    const parseResponse = JSON.parse(JSON.stringify(object));
    return parseResponse.map((advance: Advance) => {
      return infoAdvance(
        advance.receiptNumber,
        advance.orderNumber,
        advance.sellerName,
        advance.clientName,
        advance.methodOfPayment,
        advance.paymentDate,
        advance.value,
        advance.state,
        advance.url,
        advance.cancelUrl,
        advance.vouchers,
        advance.key,
        advance.sellerCode,
        advance.cancellationComments
      );
    });
  }

  return {
    infoAdvance,
    advanceCancelRequest,
    deserialize,
  };
}
